import { Menu, MenuItem } from "@mui/material";
import React, { useCallback } from "react";
import { BsThreeDotsVertical } from "react-icons/bs";
import styled from "styled-components";
import { ExpenseService } from "../../../_service/ExpenseService";
import { Notify, Utils } from "../../../utils";


const UserCardWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: white;
  padding: 0.9rem;
  margin-bottom: 0.5rem;
  border-radius: 8px;
  border: 2px solid #e5e5ea;
`;

const Avatar = styled.div<{ bg?: string }>`
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background-color: ${(props) => props.bg || "#dfe6e9"};
  color: #2d3436;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  margin-right: 1rem;
  font-size: 0.8rem;
`;

const UserInfo = styled.div`
  flex: 1;
`;

const UserName = styled.div`
  font-weight: bold;
  margin-bottom: 0.25rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
`;

const RoleList = styled.div`
  font-size: 0.875rem;
  color: #555;
  text-transform: capitalize;
`;

interface StatusBadgeProps {
  status: string;
}

const StatusBadge = styled.span<StatusBadgeProps>`
  background-color: ${(props) =>
    props.status === "Invited"
      ? "#33865D"
      : props.status === "Active"
      ? "#27ae60"
      : "#bdc3c7"};
  color: white;
  padding: 2px 10px;
  font-size: 0.75rem;
  border-radius: 4px;
  font-weight: 500;
`;

const AddButton = styled.button`
  color: #219150;
  background-color: #ffffff;
  border: none;
  padding: 0.4rem 0.935rem;
  border-radius: 6px;
  font-size: 0.875rem;
  cursor: pointer;
  border: 1px solid #27ae60;

  &:hover {
    background-color: #219150;
    color: #ffffff;
  }
`;

const UserExpenseCard = ({
  user,
  id,
  onAdd,
  onEdit,
  access,
  jobTitle,
  roles,
  refetch,
  bgColor,
  expenseId
}: any) => {
  const showStatusBadge =
    user?.status ||
    (access === "invited" ? "Invited" : access === "granted" ? "" : null);

  console.log("userData", user, access, roles, jobTitle);

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement | SVGElement>(null);

  const handleRevokeAccess = useCallback(async (id: number) => {
    try {
      const { status } = await ExpenseService._revokeExpenseAccess(id);
      if (status >= 200 && status < 300) {
        Notify("Employee access revoked successfully!", 1);
        refetch();
      }
    } catch (error: any) {
      Utils.showErrorMessage(error);
    }

  }, [id]);




  return (
    <UserCardWrapper>
      <div style={{ display: "flex" }}>
        <Avatar bg={bgColor}>
          {user?.name
            ?.split(" ")
            .map((n: any) => n?.[0])
            ?.join("")}
        </Avatar>
        <UserInfo>
          <UserName>
            {user?.name}
            {showStatusBadge && (
              <StatusBadge status={showStatusBadge}>
                {showStatusBadge}
              </StatusBadge>
            )}
          </UserName>
          <div
            style={{
              display: "flex",
              gap: "0.5rem",
              flexWrap: "wrap",
              alignItems: "center",
            }}
          >
            <RoleList>{jobTitle}</RoleList>
            {roles?.length > 0 && <span>{" - "}</span>}
            <RoleList>{roles?.join(" · ")}</RoleList>
          </div>
        </UserInfo>
      </div>

      <div>
        {access === "none" && (
          <AddButton
            onClick={() =>
              onAdd({
                id: id,
                name: user.name,
                firstName: user?.first_name,
                lastName: user?.last_name,
                roles: roles,
                email: user.email,
                jobTitle: user.jobTitle,
                isStaff: user.is_staff,
              })
            }
          >
            Invite User
          </AddButton>
        )}
        {(access === "granted" || access === "invited") && (
          <div>
            <BsThreeDotsVertical
              size={24}
              color="#999999"
              style={{ cursor: "pointer" }}
              onClick={(event) => setAnchorEl(event.currentTarget)}
            />
            <Menu
              anchorEl={anchorEl}
              open={Boolean(anchorEl)}
              onClose={() => setAnchorEl(null)}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "right",
              }}
              transformOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
            >
              {access === "granted" && <MenuItem
                onClick={() => {
                  // Handle update 
                  onEdit({
                  id: id,
                  isEdit: true,
                  name: user.name,
                  firstName: user?.first_name,
                  lastName: user?.last_name,
                  roles: roles,
                  email: user.email,
                  jobTitle: user.jobTitle,
                  });
                  console.log("Update clicked", id);
                  setAnchorEl(null);
                }}
              >
                Update
              </MenuItem>}
              <MenuItem
                onClick={() => {
                  // Handle revoke access
                  console.log("Revoke access clicked", expenseId);
                  handleRevokeAccess(expenseId);
                  setAnchorEl(null);
                }}
                sx={{ color: "#e74c3c" }}
              >
                Revoke
              </MenuItem>
            </Menu>
          </div>
        )}
      </div>
    </UserCardWrapper>
  );
};

export default UserExpenseCard;
